import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

type Props = {
  mode: "prev" | "next";
  nextPrevChapterNum: number;
  nextPrevQuestionNum: number;
  onClick?: () => void;
};

export const QuestionNavButton: FC<Props> = ({
  mode,
  nextPrevChapterNum,
  nextPrevQuestionNum,
  onClick,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const route = `/chapter/${nextPrevChapterNum}/question/${nextPrevQuestionNum}`;

  const handleOnClick = () => {
    if (onClick) onClick();
    navigate(route);
  };

  return (
    <button
      onClick={handleOnClick}
      className="border-rust-50 border hover:bg-rust-10 text-rust-50 hover:text-rust-300 font-light py-2 px-4 rounded"
      type="button"
    >
      <p className="flex text-sm sm:text-base items-center">
        {mode === "prev" && (
          <ChevronLeftIcon className="h-4 w-4 sm:h-6 sm:w-6 mr-3" />
        )}
        {mode === "prev"
          ? t("question.navButtons.previous")
          : t("question.navButtons.next")}
        {mode === "next" && (
          <ChevronRightIcon className="h-4 w-4 sm:h-6 sm:w-6 ml-3" />
        )}
      </p>
    </button>
  );
};
